import { useCallback, useMemo } from 'react';
import styled from 'styled-components';
import iconDone from '../../assets/icons/icon_done.svg';
import { ReactComponent as ExamReactComponent } from '../../assets/icons/exam.svg';
import { ReactComponent as LessonReactComponent } from '../../assets/icons/lesson.svg';
import { ReactComponent as MonitoringReactComponent } from '../../assets/icons/monitoring.svg';
import { ReactComponent as TutoringReactComponent } from '../../assets/icons/tutoring.svg';
import { ReactComponent as HomeReactComponent } from '../../assets/icons/home.svg';
import { ReactComponent as AnalyticsReactComponent } from '../../assets/icons/analytics.svg';
import { ReactComponent as MaterialReactComponent } from '../../assets/icons/material.svg';
import { ReactComponent as ProfileReactComponent } from '../../assets/icons/profile.svg';
import { ReactComponent as LogoutReactComponent } from '../../assets/icons/logout.svg';
import { ReactComponent as ChemistryReactComponent } from '../../assets/icons/chemistry.svg';
import { ReactComponent as MedCoinReactComponent } from '../../assets/icons/med_coin.svg';
import { ReactComponent as YoutubeReactComponent } from '../../assets/icons/logos_youtube.svg';
import { ReactComponent as HandoutReactComponent } from '../../assets/icons/handout.svg';
import { ReactComponent as DwonloadReactComponent } from '../../assets/icons/download.svg';

type PropsIcon = {
    className?: string;
    style?: React.CSSProperties,
    checked?: boolean,
}


export enum TypeIcons {
    exam,
    lesson,
    monitoring,
    tutoring,
    home,
    analytics,
    material,
    profile,
    logout,
    chemistry,
    medCoin,
    youtube,
    handout,
    download
}

const IconComponentAux = ({ className, type, checked, style }: PropsIcon & { type: TypeIcons }) => {
    const getIcon = useCallback((type: TypeIcons) => {
        switch (type) {
            case TypeIcons.exam:
                return ExamReactComponent;
            case TypeIcons.lesson:
                return LessonReactComponent;
            case TypeIcons.monitoring:
                return MonitoringReactComponent;
            case TypeIcons.tutoring:
                return TutoringReactComponent;
            case TypeIcons.home:
                return HomeReactComponent;
            case TypeIcons.analytics:
                return AnalyticsReactComponent;
            case TypeIcons.material:
                return MaterialReactComponent;
            case TypeIcons.profile:
                return ProfileReactComponent;
            case TypeIcons.logout:
                return LogoutReactComponent;
            case TypeIcons.chemistry:
                return ChemistryReactComponent;
            case TypeIcons.medCoin:
                return MedCoinReactComponent;
            case TypeIcons.youtube:
                return YoutubeReactComponent;
            case TypeIcons.handout:
                return HandoutReactComponent;
            case TypeIcons.download:
                return DwonloadReactComponent;
        }
    }, []);

    const icon = useMemo(() => {
        const Component = getIcon(type);
        if (checked) return <div style={{ position: 'relative' }}>
            <Component className={className} style={style} />
            <img style={{ position: 'absolute', margin: 0, right: '-2px', bottom: '-2px', height: '.8rem' }} src={iconDone} alt="Done" />
        </div>;
        return <Component className={className} style={style} />;
    }, [checked, className, getIcon, style, type]);

    return icon;
}

export const IconComponent = styled(IconComponentAux)`
    color: ${props => props.theme.colors.primary};
    font-size: 1.2rem;
`;

export const ExamIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.exam} />
export const LessonIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.lesson} />
export const MonitoringIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.monitoring} />
export const TutoringIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.tutoring} />
export const HomeIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.home} />
export const AnalyticsIon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.analytics} />
export const MaterialIon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.material} />
export const ProfileIon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.profile} />
export const LogoutIon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.logout} />
export const ChemistryIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.chemistry} />
export const MedCoinIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.medCoin} />
export const YoutubeIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.youtube} />
export const HandoutIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.handout} />
export const DownloadIcon = (props: PropsIcon) => <IconComponent {...props} type={TypeIcons.download} />





